import './tooltip';
import { aqiSmoothColor } from '../common/colors';
var Station = /** @class */ (function () {
    function Station(auth, source, model) {
        this.auth = auth;
        this.source = source;
        this.model = model;
        this.m_visible = true;
        this.m_highlighted = false;
        this.m_coords = { x: 0, y: 0 };
        this.m_initial_outdated = model.dhours || 0;
        this.m_initial_AQI = model.aqi;
    }
    Object.defineProperty(Station.prototype, "geo", {
        get: function () {
            return this.model.geo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "idx", {
        get: function () {
            return this.model.stationIdx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "AQI", {
        get: function () {
            return this.model.aqi;
        },
        enumerable: false,
        configurable: true
    });
    Station.prototype.color = function () {
        if (this.isOutdated) {
            return '#cccccc';
        }
        if (this.model.color) {
            var v = this.model.color;
            var sv = v.toString(16);
            if (sv.length > 6) {
                sv = sv.substring(sv.length - 6);
            }
            else if (sv.length < 6) {
                for (var i = sv.length; i < 6; i++) {
                    sv = '0' + sv;
                }
            }
            return "#" + sv;
        }
        return aqiSmoothColor(this.model.aqi);
    };
    Station.prototype.resetAQI = function () {
        this.model.dhours = this.m_initial_outdated;
        this.model.aqi = this.m_initial_AQI;
    };
    Station.prototype.setAQI = function (aqi) {
        this.model.dhours = 0;
        this.model.aqi = aqi;
    };
    Object.defineProperty(Station.prototype, "isOutdated", {
        get: function () {
            return (this.model.dhours || 0) > 8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "isHighlighted", {
        get: function () {
            return this.m_highlighted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "zIndex", {
        get: function () {
            if (this.isOutdated) {
                return 0;
            }
            if (this.model.color) {
                return (this.model.color >> 24) & 0xff;
            }
            return this.model.aqi;
        },
        enumerable: false,
        configurable: true
    });
    Station.prototype.updateCoords = function (coords, visible) {
        this.m_visible = visible;
        this.m_coords = coords;
    };
    Object.defineProperty(Station.prototype, "coords", {
        get: function () {
            return this.m_coords;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "isVisible", {
        get: function () {
            return this.m_visible;
        },
        enumerable: false,
        configurable: true
    });
    Station.prototype.show = function () {
        this.m_visible = true;
        this.m_highlighted = false;
    };
    Station.prototype.highlight = function () {
        this.m_visible = true;
        this.m_highlighted = true;
    };
    Station.prototype.hide = function () {
        this.m_visible = false;
        this.m_highlighted = false;
    };
    Station.prototype.readings = function () {
        if (!this.readingsPromise) {
            this.readingsPromise = this.auth
                .station(this.source, this.model.stationIdx)
                .then(function (x) {
                if (x.status != 'ok') {
                    throw x.reason;
                }
                return x.result;
            });
        }
        return this.readingsPromise;
    };
    Station.prototype.historic = function (specie, durationInDays) {
        return this.auth.historic(this.source, this.model.stationIdx, specie, durationInDays);
    };
    return Station;
}());
export { Station };
